// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { headerClickableStyles } from "@synd/App/Components/Header/HeaderClickable";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { color, xScreen } from "@synd/XDL/Utilities";
import { css } from "styled-components";

headerClickableStyles.clickable = {
    css: css`
        display: flex;
        gap: 2px;
        align-items: center;
        flex-direction: column;
        ${xScreen("lte", "md")} {
            column-gap: 0;
        }
        &:hover {
            svg,
            ${TypographyStyle} {
                color: ${color("common.ui10")};
            }
        }
    `,
};

headerClickableStyles.icon = {
    size: 19,
    color: "common.ui9",
    css: css`
        &,
        svg {
            width: 20px;
        }
    `,
};

headerClickableStyles.title = {
    size: fontConfig.xSmall.size,
    color: "common.ui6",
    css: css`
        line-height: ${fontConfig.xSmall.lineHeight};
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        white-space: nowrap;
        text-transform: uppercase;
    `,
};

headerClickableStyles.subTitle = {
    weight: fontConfig.weight.regular,
    css: css`
        max-width: 130px;
        overflow: hidden;
        text-overflow: ellipsis;
    `,
};

headerClickableStyles.openColor = "common.ui10";
